import { render, staticRenderFns } from "./ANxClarificationsPage.vue?vue&type=template&id=2315bb64"
import script from "./ANxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./ANxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./ANxClarificationsPage.vue?vue&type=style&index=0&id=2315bb64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports